"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle powermail forms
 *
 * @namespace
 * @memberOf txGs1Base.forms
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.forms.powermail = {
    /**
     * Initialize class and markup replacement
     */
    initialize: function () {
        var $context = $('.tx_powermail_pi1_form');
        if ($context.length > 0) {
            var $originalSubmitWrap = $('fieldset .field-wrap-submit', $context);
            if ($originalSubmitWrap.length > 0) {
                var $clonedSubmitWrap = $originalSubmitWrap.clone(true);
                $context.append($clonedSubmitWrap.attr('id', $clonedSubmitWrap.attr('id') + '_clone'));
                $('button', $clonedSubmitWrap).on('click', function (event) {
                    event.preventDefault();
                    $('button', $originalSubmitWrap).trigger('click');
                });
                $originalSubmitWrap.addClass('visually-hidden');
            }
        }
    }
};
exports.default = {};
